var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column mx-4 flex-shrink-0"},[_c('span',{staticClass:"caption text-uppercase text--disabled"},[_vm._v("Current term")]),_c('span',{staticClass:"text-body-1"},[_c('b',[_vm._v(_vm._s(_vm.term || '-'))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }